export const createButton = (title, className) => {
  const btn = document.createElement(`button`);
  btn.type = `button`;
  btn.className = className;
  btn.innerHTML = title;

  return btn;
};
